// extracted by mini-css-extract-plugin
export default {"notificationCount":"DueChildTrainingSkillIcon_notificationCount__YGZgc"};